import React, { useEffect } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { Card, Col, Container, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import PageHeader from '../../components/PageHeader';
import { useDispatch, useSelector } from 'react-redux';
import { getListReportOptions } from './reportHelper';
import { fetchFavReports } from '../add-to-favourite/favReportSlice';
import { LoadingState } from '../../utilities/constants';
import { useTranslation } from 'react-i18next';

const ViewReports = () => {
  const { t } = useTranslation();
  const favReports = useSelector((state) => state.favouriteReports.favReports);
  const favReportsStatus = useSelector((state) => state.favouriteReports.status);
  const match = useRouteMatch();
  const dispatch = useDispatch();

  const routes = getListReportOptions(t).map((item) => ({
    name: item.label,
    path: item.path,
    route: `${match.path}/${item.path}`,
    key: item.value,
    tooltip: item.tooltip,
  }));

  const { usrOrgId: orgId, usrId, optAvailableReports } =
    useSelector((state) => state.users.user);

  const checkShowReport = (reportName) => {
    if (!optAvailableReports?.length) {
      return true;
    }
    return optAvailableReports.includes(reportName);
  };

  useEffect(() => {
    if (favReportsStatus === LoadingState.idle && usrId) {
      dispatch(fetchFavReports({ orgId, usrId }));
    }
  }, [t, match.path, dispatch, orgId, usrId, favReports, favReportsStatus]);

  const filterredFavReports = favReports.filter(({ frRepCategoryName }) => {
    const route = routes.find(({ path }) => path === frRepCategoryName);
    return checkShowReport(route?.key);
  });

  return (
    <Container fluid>
      <Row className="pr-4 mt-2">
        {filterredFavReports && filterredFavReports.length ?
          (
            <Col sm={12}>
              <PageHeader.Secondary title={t("Favourite Reports")} />
            </Col>
          ) : null}
        {filterredFavReports &&
          filterredFavReports.map((doc) => {
            const params = new URLSearchParams({
              filter: btoa(doc.frRepParamJson),
              frName: doc.frName,
              frUsrId: doc.frUsrId,
            });
            return (
              <Col
                key={doc.frName}
                  sm={4}
                  className="pr-10 pt-3"
                  to={`${match.path}/${doc.frRepCategoryName}?${params.toString()}`}
                  as={Link}
                >
                  <Card className="favourite-report-card">
                    <Card.Body>
                      <p className="text-center">
                        <strong>{doc.frName}</strong>
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
            );
          })}
      </Row>
      <Row className="mt-4 pr-4 mb-4">
        <Col sm={12}>
          <PageHeader.Secondary title={t("General Reports")} />
        </Col>
        {routes.filter(({ key }) => checkShowReport(key)).map(({ route, name, tooltip }) => (
          <OverlayTrigger
            key={name}
            placement="top"
            overlay={tooltip ? <Tooltip className="wide-tooltip">{tooltip}</Tooltip> : <span />}
          >
            <Col sm={4} className="pr-10 pt-3" to={route} as={Link}>
              <Card className="general-report-card">
                <Card.Body>
                  <p className="text-center">
                    <strong>{name}</strong>
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </OverlayTrigger>
        ))}
      </Row>
    </Container>
  );
};

export default ViewReports;
